module.exports = "/_next/static/pages/partners/cdab559da879ea04d837ae82659019a0.png";